import axios from "axios";
import { Auth } from "aws-amplify";
import Config from "../../../../config";

import { PROJECT_GET } from "..";

axios.defaults.headers.common["Content-Type"] =
  "application/json;charset=UTF-8";

export const api_update_demand_file = (data) => {
  return Auth.currentSession()
    .then((session) => {
      const token = session && session.idToken.jwtToken;

      var config = { headers: { Authorization: "Bearer " + token } };
      return axios
        .put(`${Config.API_BASE_URL}/v2/client-project/demandFile`, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    })
    .catch((error) => {});
};
